import styled from 'styled-components';

const SkipLink = styled.a`
  position: absolute;
  top: -100px;
  left: 0;
  z-index: 100;
  padding: 0.75rem 1.5rem;
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.primaryForeground};
  text-decoration: none;
  font-weight: 600;
  border-radius: 0 0 ${props => props.theme.borderRadius.md} 0;
  transition: top 0.2s;
  
  &:focus {
    top: 0;
    outline: 2px solid ${props => props.theme.colors.ring || props.theme.colors.primary};
    outline-offset: 2px;
  }
`;

const SkipToContent = ({ targetId = 'main-content' }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.focus();
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <SkipLink href={`#${targetId}`} onClick={handleClick}>
      Skip to main content
    </SkipLink>
  );
};

export default SkipToContent;



